// extracted by mini-css-extract-plugin
export default {"root":"SearchInput_root__1NhYY","input":"SearchInput_input__4KUFe","icon-override":"SearchInput_icon-override__203PE"};